import { useMemo } from "react";

import SectionHeadingTabs from "~/components/headings/SectionHeadingTabbar";
import { SUBSECTION_PARAM_NAME, useSearchParamTab } from "~/hooks/useSearchParamTab.ts";
import type { ProjectBillingSubsection } from "~/modules/project/types/projectViewTypes.ts";
import { ProjectDetailsTabName } from "~/modules/project/types/projectViewTypes.ts";
import type { SectionHeadingTab } from "~/types/tabsTypes.ts";

type Props = {
	activeSubsection: ProjectBillingSubsection;
	projectId: string;
};

const BILLING_SUBSECTIONS: ProjectBillingSubsection[] = [
	ProjectDetailsTabName.BillingSettings,
	ProjectDetailsTabName.Invoices,
];

const BillingTabSubNavigation = ({ activeSubsection }: Props) => {
	const [, setSubsection] = useSearchParamTab<ProjectBillingSubsection>(
		SUBSECTION_PARAM_NAME,
		BILLING_SUBSECTIONS,
		ProjectDetailsTabName.BillingSettings,
	);

	const tabs = useMemo(() => {
		const tabs: SectionHeadingTab[] = [
			{
				name: "Abrechnungsdetails",
				value: ProjectDetailsTabName.BillingSettings,
				active: activeSubsection === ProjectDetailsTabName.BillingSettings,
			},
			{
				name: "Rechnungen",
				value: ProjectDetailsTabName.Invoices,
				active: activeSubsection === ProjectDetailsTabName.Invoices,
			},
		];
		return tabs;
	}, [activeSubsection]);

	return <SectionHeadingTabs tabs={tabs}
							   onTabClick={setSubsection} />;
};

export default BillingTabSubNavigation;
